import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getContents } from "../lib/api/contents";
import { qk } from "../lib/queryKeys";
import type { ContentsResponse } from "../lib/api/types";

export function useContents(folderId: string | null) {
  return useQuery<ContentsResponse>({
    queryKey: qk.contents(folderId),
    queryFn: () => getContents(folderId),
    placeholderData: keepPreviousData,
  });
}
